export default __webpack_public_path__ + "static/media/basic-profile-image.5fa38171.jpg";